module.exports = __webpack_public_path__ + "static/media/specjalist-icon.6395ce55.png";